import { Inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { DOCUMENT } from '@angular/common';
import { filter, interval, map } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ServiceWorkerService {
  constructor(
    private swUpdate: SwUpdate,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
  ) {
    if (swUpdate.isEnabled) {
      interval(5 * 1000).subscribe(() =>
        swUpdate.checkForUpdate().then(() => console.log('checking for updates')),
      );
    } else {
      console.log('Service Worker is not enabled in this browser.');
    }
  }

  public checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker updates are disabled.');
      return;
    }
    
    this.swUpdate.versionUpdates.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
    .subscribe((data) => {
      if (this.router.url.includes('/auth')) {
        this.refresh();
      } else {
        const userConfirmed = confirm('A new version is available. Would you like to update?');
        if (userConfirmed) {
          this.refresh();
        }
      }
    });
  }

  private async refresh() {
    this.swUpdate.activateUpdate().then(() => {
      console.log('Activating update...');
      // Force a complete refresh to avoid cache issues
      window.location.reload(); // Ensures a full reload
    });
  }
}
